import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "post d-flex flex-column-fluid",
  id: "kt_post"
}
const _hoisted_2 = {
  id: "kt_content_container",
  class: "container-xxl"
}
const _hoisted_3 = { class: "row justify-content-end align-items-center mb-10 negative-top" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-4" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "fs-1 fw-bold" }, "Roles y permisos")
], -1)
const _hoisted_5 = { class: "col-sm-4" }
const _hoisted_6 = {
  key: 0,
  class: "input-group input-group-lg"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  class: "form-control",
  placeholder: "Buscar rol"
}, null, -1)
const _hoisted_8 = { class: "input-group-text" }
const _hoisted_9 = { class: "col-sm-4 d-flex justify-content-end" }
const _hoisted_10 = { class: "row row-cols-1 row-cols-md-2 row-cols-xl-3 g-5 g-xl-9" }
const _hoisted_11 = { class: "card card-flush h-md-100" }
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "card-title pt-3" }
const _hoisted_14 = { class: "fs-2 fw-bold" }
const _hoisted_15 = { class: "card-body text-white pt-1" }
const _hoisted_16 = { class: "fs-sm mb-5" }
const _hoisted_17 = { class: "d-flex flex-column text-gray-700" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot h-8px w-8px bg-primary me-3" }, null, -1)
const _hoisted_19 = {
  key: 0,
  class: "d-flex align-items-center py-2"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot h-8px w-8px bg-primary me-3" }, null, -1)
const _hoisted_21 = { class: "fs-sm" }
const _hoisted_22 = { class: "card-footer flex-wrap pt-0 fs-4" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "isax-edit-2 text-white fs-5" }, null, -1)
const _hoisted_25 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_26 = { class: "card h-md-100" }
const _hoisted_27 = { class: "card-body d-flex flex-column flex-center" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  src: "media/images/new-role.png",
  alt: "",
  class: "mw-100 mh-150px mb-8"
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "fw-bold fs-5 text-white mb-8" }, "Agregar nuevo Rol", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ModalRoleForm = _resolveComponent("ModalRoleForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(_component_inline_svg, { src: "media/icons/iconsax/search-normal.svg" })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("button", {
            class: "btn btn-primary fs-base",
            "data-bs-toggle": "modal",
            "data-bs-target": "#kt_modal_add_role",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cleanEditRole()))
          }, " Agregar rol ", 512), [
            [_vShow, _ctx.$can('Crear rol')]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rolesData, (role) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-md-4",
            key: role.id
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("h2", _hoisted_14, _toDisplayString(role.name_rol), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(role.role_count_user) + " usuarios con el rol", 1),
                _createElementVNode("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(role.role_list_access.slice(0, 3), (access) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "d-flex align-items-center py-2 fs-sm",
                      key: access.idAccess
                    }, [
                      _hoisted_18,
                      _createTextVNode(" " + _toDisplayString(access.name_access), 1)
                    ]))
                  }), 128)),
                  (
                    role.role_list_access.length -
                      role.role_list_access.slice(0, 3).length >
                    0
                  )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _hoisted_20,
                        _createElementVNode("span", _hoisted_21, _toDisplayString(role.role_list_access.length -
                      role.role_list_access.slice(0, 3).length) + " permisos más", 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                (role.active_edit > 0)
                  ? _withDirectives((_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-primary btn-active-light my-1 me-2 fs-base",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#kt_modal_add_role",
                      onClick: ($event: any) => (_ctx.editRole(role))
                    }, [
                      _hoisted_24,
                      _createTextVNode(" Editar ")
                    ], 8, _hoisted_23)), [
                      [_vShow, _ctx.$can('Editar rol')]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.$can('Ver detalle de rol'))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      class: "btn btn-secondary btn-active-primary my-1 me-2 fs-base",
                      to: 
                  _ctx.$can('Ver detalle de rol')
                    ? { name: 'role-detail', params: { id: role.id } }
                    : {}
                
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Ver detalle ")
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        }), 128)),
        (_ctx.$can('Crear rol'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _hoisted_29,
                  _withDirectives(_createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary btn-active-secondary fs-base my-1 me-3",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#kt_modal_add_role",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cleanEditRole()))
                  }, " Crear nuevo ", 512), [
                    [_vShow, _ctx.$can('Crear rol')]
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ModalRoleForm, {
      onSendData: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getRoleData($event))),
      roleToEdit: _ctx.roleEdit,
      typeForm: _ctx.typeForm
    }, null, 8, ["roleToEdit", "typeForm"])
  ]))
}